import { ChatMessage } from '../hooks/useFullChatMessages';
import React from 'react';

interface ChatMessageItemProps {
  message: ChatMessage;
}

export const ChatMessageItem: React.FC<ChatMessageItemProps> = ({
  message,
}) => {
  const isUser: boolean = message.role === 'user';
  const isAgent: boolean = message.role === 'agent';

  const containerClasses: string = `flex w-full ${isUser ? 'justify-start' : 'justify-end'}`;

  const bubbleClasses: string = `max-w-[85%] p-3 rounded-lg shadow-sm overflow-hidden break-words ${
    isUser
      ? 'bg-white text-gray-800 rounded-bl-none border border-gray-200'
      : isAgent
        ? 'bg-green-100 text-green-900 rounded-br-none border border-green-200'
        : 'bg-blue-100 text-blue-900 rounded-br-none'
  }`;

  const roleLabel: string = isUser
    ? 'Usuario'
    : isAgent
      ? 'Agente'
      : 'Asistente';

  return (
    <div className={containerClasses}>
      <div className={bubbleClasses}>
        <div className='flex justify-between items-baseline gap-4 mb-1'>
          <span className='font-bold text-xs uppercase tracking-wider opacity-70'>
            {roleLabel}
          </span>
          {message.dt && (
            <span className='text-[10px] opacity-50'>
              {new Date(message.dt).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
              })}
            </span>
          )}
        </div>
        <p className='text-sm whitespace-pre-wrap leading-relaxed break-words overflow-hidden'>
          {message.content}
        </p>
      </div>
    </div>
  );
};
